// extracted by mini-css-extract-plugin
module.exports = {"contact-page-slider__button-icon":"ContactPageSliderButtonIcon_contact-page-slider__button-icon__iUBy6"};